document.addEventListener('click', async e => {
  const link = e.target.closest('[data-info-handle]');
  if (!link) return;

  e.preventDefault();

  const drawer = document.querySelector('custom-info-drawer');
  if (!drawer) return;

  const handle = link.dataset.infoHandle;
  if (!handle) return;

  try {
    const res = await fetch(`/pages/${handle}?section_id=main-page`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector('.shopify-section') || doc.body;

    const contentEl = drawer.querySelector('[data-custom-info-drawer-content]');
    contentEl.innerHTML = section.innerHTML || '<p>Couldn’t load content.</p>';
    drawer.querySelector('.custom-info-title').textContent = '';
    drawer.classList.add('active');
  } catch (err) {
    console.error('Error loading info drawer:', err);
  }
});

document.addEventListener('click', e => {
  const drawer = document.querySelector('custom-info-drawer');
  if (!drawer) return;

  // Close if X button clicked
  if (e.target.closest('.custom-info-close')) {
    drawer.classList.remove('active');
  }

  // Optional: close if clicking outside drawer
  if (!drawer.contains(e.target) && drawer.classList.contains('active')) {
    drawer.classList.remove('active');
  }
});